<template>
    <div class="ku-order-info">
        <div class="tit" v-show="!err_show">支付订单</div>
        <div class="money" v-show="!err_show">{{ money }}</div>
        <van-button type="info" v-show="!err_show" @click="onPay">支付</van-button>
        <van-empty image="error" :description="err" v-show="err_show" />
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Button, Dialog, Empty} from 'vant';
    import {UrlSearch} from "@/utils/fu";

    Vue.use(Button).use(Empty);
    export default {
        name: "index",
        data() {
            return {
                err_show: false,
                err: '',
                order_no: '',

                money: '',
                payConfig: [],
            }
        },
        mounted() {
            let href = new UrlSearch();
            this.order_no = href.sn;
            this.onLoad()
        },
        methods: {
            onLoad() {
                let _that = this;
                if (!_that.order_no) {
                    _that.err_show = true
                    _that.err = '参数错误，请重新扫码'
                    return false;
                }
                this.$API.orderInfo({no: this.order_no}).then(res => {
                    return res.data;
                }).then(res => {
                    let data = res.data;
                    if (data.pay_status !== 1) {
                        _that.err_show = true
                        _that.err = '订单支付超时或已支付'
                    } else {
                        _that.money = data.price
                        _that.shop_id = data.shop_id
                    }
                });
            },
            onPay() {
                let that = this
                that.$API.orderPay({no: this.order_no}).then(res => {
                    return res.data
                }).then(res => {
                    if (res.code === 1) {
                        that.payConfig = res.data;
                        if (typeof WeixinJSBridge == "undefined"){
                            if( document.addEventListener ){
                                document.addEventListener('WeixinJSBridgeReady', that.wxpay(res.data), false);
                            }else if (document.attachEvent){
                                document.attachEvent('WeixinJSBridgeReady', that.wxpay(res.data));
                                document.attachEvent('onWeixinJSBridgeReady',that.wxpay(res.data));
                            }
                        }else{
                            that.wxpay();
                        }
                    } else {
                        Dialog.alert({
                            message: '支付失败：' + res.msg,
                        })
                    }
                })
            },
            wxpay() {
                let that = this;
                /* eslint-disable */
                WeixinJSBridge.invoke(
                    "getBrandWCPayRequest",
                    {
                        appId: this.payConfig.appId, //公众号名称，由商户传入
                        timeStamp: this.payConfig.timeStamp, //时间戳，自1970年以来的秒数
                        nonceStr: this.payConfig.nonceStr, //随机串
                        package: this.payConfig.package,
                        signType: this.payConfig.signType, //微信签名方式：
                        paySign: this.payConfig.paySign //微信签名
                    },
                    function(res) {
                        // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                        if(res.err_msg == "get_brand_wcpay_request:ok" ){ //支付成功后的操作
                            Dialog.alert({
                                message: '支付成功',
                            })
                            that.onPayOk();
                        }else if(res.err_msg == 'get_brand_wcpay_request:cancel'){ //取消支付的操作
                            Dialog.alert({
                                message: '取消支付',
                            })
                        }else{ //支付失败的操作
                            Dialog.alert({
                                message: '支付失败',
                            })
                        }
                        that.show = false
                    }
                );
            },
        },
    }
</script>

<style lang="less" scoped>
.ku-order-info {
    .tit {
        font-size: 40px;
        margin-top: 50px;
    }
    .money {
        margin: 80px 30px;
        text-align: center;
        font-size: 35px;
        border-bottom: 1px solid #ccc;
        padding: 20px 0;
    }
    .van-button {
        width: 300px;
        border-radius: 10px;
    }
}
</style>
